import Vue from "vue";
import VueI18n from "vue-i18n";
import dashBoardData from "./dashboard";
import leads from "./leads";
import reports from "./reports";
import customers from "./customers";
import sidebar from "./sidebar";
import ticketData from "./ticketing";
import entity from "./entity";
import common from "./common";
import inventoryData from "./inventory";
import system from "./system";
import adminData from "./admin";
import setupData from "./setup";
import profile from "./profile";
import bill_management from "./billManagement";
import accounting from "./accounting";
import placeholder from "./placeholder";
import selectDate from "./selectDate";

const sources = [
  dashBoardData,
  sidebar,
  leads,
  reports,
  customers,
  entity,
  common,
  ticketData,
  inventoryData,
  system,
  adminData,
  setupData,
  profile,
  bill_management,
  accounting,
  placeholder,
  selectDate,
];

const generateMessages = function (sources) {
  const messages = {};
  for (const source of sources) {
    messages.en = { ...messages.en, ...source.en };
    messages.fr = { ...messages.fr, ...source.fr };
    messages.es = { ...messages.es, ...source.es };
    messages.pt = { ...messages.pt, ...source.pt };
    messages.zh_CN = { ...messages.zh_CN, ...source.zh_CN };
    messages.hi = { ...messages.hi, ...source.hi };
    messages.ka = { ...messages.ka, ...source.ka };
    messages.lo = { ...messages.lo, ...source.lo };
    messages.my_MM = { ...messages.my_MM, ...source.my_MM };
    messages.my = { ...messages.my, ...source.my };
    messages.vi = { ...messages.vi, ...source.vi };
  }
  return messages;
};
Vue.use(VueI18n);
export default new VueI18n({
  locale: "en",
  silentTranslationWarn: true,
  messages: generateMessages(sources),
});
